"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenExpression = exports.isWorkflowApproval = exports.isApproval = exports.isOperator = exports.isWorkflowCondition = void 0;
const isWorkflowCondition = (expression) => expression === null || expression === void 0 ? void 0 : expression.condition;
exports.isWorkflowCondition = isWorkflowCondition;
const isOperator = (expression) => expression === null || expression === void 0 ? void 0 : expression.operator;
exports.isOperator = isOperator;
const isApproval = (expression) => (expression === null || expression === void 0 ? void 0 : expression.approverType) && (expression === null || expression === void 0 ? void 0 : expression.approver);
exports.isApproval = isApproval;
const isWorkflowApproval = (expression) => (expression === null || expression === void 0 ? void 0 : expression.approverType) && !(expression === null || expression === void 0 ? void 0 : expression.approver);
exports.isWorkflowApproval = isWorkflowApproval;
/**
 *
 * @returns array of sub-expressions of type T inside a logical expression.
 *
 * Note: This is a recursive function.
 */
const flattenExpression = (expression, expressions = []) => {
    if ((0, exports.isOperator)(expression)) {
        for (const operand of expression.operands) {
            (0, exports.flattenExpression)(operand, expressions);
        }
        return expressions;
    }
    expressions.push(expression);
    return expressions;
};
exports.flattenExpression = flattenExpression;
